/* MoRetro Studio - Centre d'assistance */
window.MTS = window.MTS || {};

(function(MTS){
  "use strict";

  const API_BASE = "https://bubbly-vibrancy-production.up.railway.app";
  const STATUS_LABELS = {
    new:"Nouveau",
    progress:"En cours",
    waiting:"En attente",
    resolved:"Résolu",
    archived:"Archivé"
  };
  const PRIORITY_LABELS = {
    low:"Basse",
    normal:"Normale",
    high:"Haute",
    urgent:"Urgente"
  };

  const state = {
    tickets:[],
    selectedId:"",
    loading:false,
    loaded:false
  };

  function esc(value){
    return MTS.escapeHtml ? MTS.escapeHtml(String(value ?? "")) : String(value ?? "").replace(/[&<>"']/g, char=>({
      "&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#039;"
    })[char]);
  }

  function date(value){
    if(!value) return "Date inconnue";
    const parsed = new Date(value);
    return Number.isNaN(parsed.getTime()) ? "Date inconnue" : parsed.toLocaleString("fr-FR", {
      day:"2-digit", month:"2-digit", year:"numeric", hour:"2-digit", minute:"2-digit"
    });
  }

  async function token(){
    const user = MTS.state?.auth?.currentUser;
    if(!user?.getIdToken) throw new Error("Session Firebase administrateur indisponible.");
    return user.getIdToken();
  }

  async function request(path, options = {}){
    const authToken = await token();
    const response = await fetch(`${API_BASE}${path}`, {
      ...options,
      cache:"no-store",
      headers:{
        accept:"application/json",
        "content-type":"application/json",
        Authorization:`Bearer ${authToken}`,
        ...(options.headers || {})
      }
    });
    const data = await response.json().catch(()=>null);
    if(!response.ok || !data?.ok) throw new Error(data?.error || `Erreur assistance ${response.status}`);
    return data;
  }

  function filteredTickets(){
    const search = String(document.getElementById("mtsSupportSearch")?.value || "").trim().toLowerCase();
    const status = document.getElementById("mtsSupportStatus")?.value || "open";
    const category = document.getElementById("mtsSupportCategory")?.value || "all";

    return state.tickets.filter(ticket=>{
      const ticketStatus = ticket.status || "new";
      if(status === "open" && ["resolved","archived"].includes(ticketStatus)) return false;
      if(status !== "all" && status !== "open" && ticketStatus !== status) return false;
      if(category !== "all" && ticket.category !== category) return false;
      if(!search) return true;
      const haystack = [
        ticket.reference, ticket.name, ticket.email, ticket.subject, ticket.message,
        ticket.orderNumber, ticket.category
      ].join(" ").toLowerCase();
      return haystack.includes(search);
    });
  }

  function updateCounts(){
    const open = state.tickets.filter(ticket=>!["resolved","archived"].includes(ticket.status)).length;
    const fresh = state.tickets.filter(ticket=>(ticket.status || "new") === "new").length;
    const count = document.getElementById("mtsSupportCount");
    const newCount = document.getElementById("mtsSupportNew");
    const navCount = document.getElementById("mtsSupportNavCount");

    if(count) count.textContent = String(open);
    if(newCount) newCount.textContent = `${fresh} nouvelle(s)`;
    if(navCount){
      navCount.textContent = String(fresh);
      navCount.hidden = fresh === 0;
    }
  }

  function statusClass(status){
    return `mts-support-status mts-support-status-${esc(status || "new")}`;
  }

  function renderList(){
    const container = document.getElementById("mtsSupportList");
    if(!container) return;
    const tickets = filteredTickets();

    if(state.loading){
      container.innerHTML = '<div class="mts-empty">Chargement des demandes...</div>';
      return;
    }

    container.innerHTML = tickets.length ? tickets.map(ticket=>`
      <button type="button" class="mts-crm-item ${ticket.id === state.selectedId ? "active" : ""}" data-support-id="${esc(ticket.id)}">
        <div class="mts-crm-item-top">
          <strong>${esc(ticket.subject || "Demande sans sujet")}</strong>
          <em class="${statusClass(ticket.status)}">${esc(STATUS_LABELS[ticket.status] || ticket.status || "Nouveau")}</em>
        </div>
        <span>
          ${esc(ticket.reference || "")}<br>
          ${esc(ticket.name || "Client")} · ${esc(ticket.category || "Autre demande")}<br>
          ${esc(date(ticket.createdAt))}
        </span>
      </button>
    `).join("") : '<div class="mts-empty">Aucune demande pour ces filtres.</div>';
  }

  function selected(){
    return state.tickets.find(ticket=>ticket.id === state.selectedId) || null;
  }

  function renderHistory(ticket){
    const items = [...(ticket.history || [])].reverse();
    return items.length ? items.map(item=>`
      <div class="mts-support-history-item">
        <strong>${esc(item.label || item.type || "Mise à jour")}</strong>
        <span>${esc(date(item.at))}</span>
      </div>
    `).join("") : '<div class="mts-empty">Aucun historique.</div>';
  }

  function renderDetail(){
    const container = document.getElementById("mtsSupportDetail");
    if(!container) return;
    const ticket = selected();
    if(!ticket){
      container.innerHTML = '<div class="mts-empty">Sélectionne une demande à gauche.</div>';
      return;
    }

    container.innerHTML = `
      <div class="mts-support-detail-head">
        <div>
          <p class="mts-kicker">${esc(ticket.reference || "Assistance")}</p>
          <h3>${esc(ticket.subject || "Demande sans sujet")}</h3>
          <p>${esc(ticket.name || "Client")} · <a href="mailto:${esc(ticket.email || "")}">${esc(ticket.email || "")}</a></p>
        </div>
        <span class="${statusClass(ticket.status)}">${esc(STATUS_LABELS[ticket.status] || ticket.status || "Nouveau")}</span>
      </div>

      <div class="mts-support-meta">
        <div><strong>Catégorie</strong><span>${esc(ticket.category || "Autre")}</span></div>
        <div><strong>Reçue le</strong><span>${esc(date(ticket.createdAt))}</span></div>
        <div><strong>Commande</strong><span>${esc(ticket.orderNumber || "Non renseignée")}</span></div>
        <div><strong>Priorité</strong><span>${esc(PRIORITY_LABELS[ticket.priority] || "Normale")}</span></div>
      </div>

      ${ticket.orderIssue ? `<div class="mts-support-info"><strong>Problème de commande</strong><p>${esc(ticket.orderIssue)}</p></div>` : ""}
      ${ticket.pageUrl || ticket.device ? `<div class="mts-support-info"><strong>Contexte technique</strong><p>${ticket.pageUrl ? `Page : ${esc(ticket.pageUrl)}<br>` : ""}${ticket.device ? `Appareil : ${esc(ticket.device)}` : ""}</p></div>` : ""}

      <div class="mts-support-message">
        <strong>Message du client</strong>
        <p>${esc(ticket.message || "").replace(/\n/g,"<br>")}</p>
      </div>

      <div class="mts-support-edit-grid">
        <label>Statut
          <select id="mtsSupportEditStatus">
            ${Object.entries(STATUS_LABELS).map(([value,label])=>`<option value="${value}" ${ticket.status === value ? "selected" : ""}>${label}</option>`).join("")}
          </select>
        </label>
        <label>Priorité
          <select id="mtsSupportEditPriority">
            ${Object.entries(PRIORITY_LABELS).map(([value,label])=>`<option value="${value}" ${ticket.priority === value ? "selected" : ""}>${label}</option>`).join("")}
          </select>
        </label>
      </div>

      <label class="mts-support-field">Note interne
        <textarea id="mtsSupportInternalNote" placeholder="Informations visibles uniquement dans le Studio...">${esc(ticket.internalNote || "")}</textarea>
      </label>

      <label class="mts-support-field">Réponse au client
        <textarea id="mtsSupportResolution" placeholder="Écris ici la réponse qui sera envoyée au client...">${esc(ticket.resolution || "")}</textarea>
      </label>

      <div class="mts-actions">
        <button type="button" class="mts-btn mts-ok" id="mtsSupportSave">Enregistrer</button>
        <button type="button" class="mts-btn mts-soft" id="mtsSupportReply">Envoyer la réponse par email</button>
        <button type="button" class="mts-btn mts-danger" id="mtsSupportDelete">Supprimer</button>
      </div>

      <div class="mts-support-history">
        <h4>Historique</h4>
        ${renderHistory(ticket)}
      </div>
    `;
  }

  function render(){
    updateCounts();
    renderList();
    renderDetail();
  }

  async function load(force = false){
    if(state.loading || (state.loaded && !force)) return;
    state.loading = true;
    renderList();
    try{
      const data = await request("/api/support?limit=200");
      state.tickets = Array.isArray(data.tickets) ? data.tickets : [];
      state.loaded = true;
      if(state.selectedId && !state.tickets.some(ticket=>ticket.id === state.selectedId)) state.selectedId = "";
    }catch(err){
      console.error("Assistance indisponible :", err);
      const list = document.getElementById("mtsSupportList");
      if(list) list.innerHTML = `<div class="mts-empty">Erreur assistance : ${esc(err.message)}</div>`;
    }finally{
      state.loading = false;
      render();
    }
  }

  async function saveSelected(){
    const ticket = selected();
    if(!ticket) return;
    const button = document.getElementById("mtsSupportSave");
    if(button) button.disabled = true;
    try{
      const data = await request(`/api/support/${encodeURIComponent(ticket.id)}`, {
        method:"PATCH",
        body:JSON.stringify({
          status:document.getElementById("mtsSupportEditStatus")?.value || "new",
          priority:document.getElementById("mtsSupportEditPriority")?.value || "normal",
          internalNote:document.getElementById("mtsSupportInternalNote")?.value || "",
          resolution:document.getElementById("mtsSupportResolution")?.value || ""
        })
      });
      state.tickets = state.tickets.map(item=>item.id === ticket.id ? data.ticket : item);
      render();
    }catch(err){
      alert(`Enregistrement impossible : ${err.message}`);
    }finally{
      if(button) button.disabled = false;
    }
  }

  async function deleteSelected(){
    const ticket = selected();
    if(!ticket || !confirm(`Supprimer définitivement ${ticket.reference || "cette demande"} ?`)) return;
    try{
      await request(`/api/support/${encodeURIComponent(ticket.id)}`, {method:"DELETE"});
      state.tickets = state.tickets.filter(item=>item.id !== ticket.id);
      state.selectedId = "";
      render();
    }catch(err){
      alert(`Suppression impossible : ${err.message}`);
    }
  }

  async function replySelected(){
    const ticket = selected();
    const message = document.getElementById("mtsSupportResolution")?.value?.trim() || "";
    if(!ticket || !message){
      alert("Écris une réponse avant de l’envoyer.");
      return;
    }
    if(!confirm(`Envoyer cette réponse à ${ticket.email} ?`)) return;
    const button = document.getElementById("mtsSupportReply");
    if(button){ button.disabled = true; button.textContent = "Envoi en cours..."; }
    try{
      const data = await request(`/api/support/${encodeURIComponent(ticket.id)}/reply`, {
        method:"POST", body:JSON.stringify({message})
      });
      state.tickets = state.tickets.map(item=>item.id === ticket.id ? data.ticket : item);
      render();
      alert("Réponse envoyée au client.");
    }catch(err){
      alert(`Envoi impossible : ${err.message}`);
    }finally{
      const currentButton = document.getElementById("mtsSupportReply");
      if(currentButton){ currentButton.disabled = false; currentButton.textContent = "Envoyer la réponse par email"; }
    }
  }

  function bind(){
    ["mtsSupportSearch","mtsSupportStatus","mtsSupportCategory"].forEach(id=>{
      const element = document.getElementById(id);
      if(element) element.addEventListener(id === "mtsSupportSearch" ? "input" : "change", renderList);
    });
    document.getElementById("mtsSupportRefresh")?.addEventListener("click", ()=>load(true));
    document.getElementById("mtsSupportList")?.addEventListener("click", event=>{
      const button = event.target.closest("[data-support-id]");
      if(!button) return;
      state.selectedId = button.dataset.supportId || "";
      render();
    });
    document.getElementById("mtsSupportDetail")?.addEventListener("click", event=>{
      if(event.target.closest("#mtsSupportSave")) saveSelected();
      if(event.target.closest("#mtsSupportReply")) replySelected();
      if(event.target.closest("#mtsSupportDelete")) deleteSelected();
    });
    document.addEventListener("click", event=>{
      if(event.target.closest('.mts-nav button[data-panel="support"]')) load(true);
    });
  }

  function start(){
    bind();
    setTimeout(()=>load(false), 1800);
  }

  MTS.Support = {start, load, render, state};

  if(document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})(window.MTS);
